import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

interface WidgetShellProps {
  title?: string;
  subtitle?: string;
  titleRight?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  colSpan?: number;
  onClick?: () => void;
  noPadding?: boolean;
}

export default function WidgetShell({
  title,
  subtitle,
  titleRight,
  actions,
  children,
  className,
  contentClassName,
  colSpan = 1,
  onClick,
  noPadding,
}: WidgetShellProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'rounded-xl border border-border bg-surface-card transition-colors',
        onClick && 'cursor-pointer hover:bg-surface-card-hover',
        colSpan > 1 && `col-span-${colSpan}`,
        className
      )}
    >
      {(title || actions) && (
        <div className="flex items-center justify-between px-4 pt-4 pb-2">
          <div>
            {title && <h3 className="text-sm font-semibold text-content-primary">{title}</h3>}
            {subtitle && <p className="text-xs text-content-muted mt-0.5">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">
            {titleRight}
            {actions}
          </div>
        </div>
      )}
      <div className={cn(noPadding ? '' : 'px-4 pb-4', !title && !actions && !noPadding && 'pt-4', contentClassName)}>
        {children}
      </div>
    </div>
  );
}
